import { LoaderService } from './../../../../../shared/loader/loader.service';
import { Component } from '@angular/core';
import { ModalService } from '../../../../../shared/modal/modal.service';
import { NavbarService } from '../../../../../shared/navbar/navbar.service';
import { MenuService } from '../../../../../shared/menu/menu.service';
import { AlunosService } from '../../alunos/alunos.service';
import { InputIconComponent } from '../../../../../shared/input-icon/input-icon.component';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CheckboxComponent } from '../../../../../shared/checkbox/checkbox.component';
import { ButtonComponent } from '../../../../../shared/button/button.component';
import { RoleEnum } from '../../../../../models/role.enum';
import { EscolherAlunoComponent } from '../notas/components/escolher-aluno/escolher-aluno.component';
import { UserService } from '../../../../../shared/services/user/user.service';
import { alunoResponse } from '../../../../../models/alunos.interface';
import { ToastService } from '../../../../../shared/toast/toast.service';
import { toPost } from '../../../../../models/rest.interface';
import { Tab, TabsComponent } from '../../../../../shared/tabs/tabs.component';
import {
  OptionSelect,
  SelectComponent,
} from '../../../../../shared/select/select.component';
import { DividerComponent } from '../../../../../shared/divider/divider.component';
import { TextareaComponent } from '../../../../../shared/textarea/textarea.component';
import { switchMap } from 'rxjs';
import { StorageServiceService } from '../../../../../shared/storage/storage-service.service';

@Component({
  selector: 'app-ficha-medica',
  standalone: true,
  imports: [
    InputIconComponent,
    CheckboxComponent,
    ButtonComponent,
    TabsComponent,
    SelectComponent,
    DividerComponent,
    TextareaComponent,
  ],
  templateUrl: './ficha-medica.component.html',
  styleUrl: './ficha-medica.component.scss',
})
export class FichaMedicaComponent {
  tabs: Tab[] = [
    {
      icon: '',
      label: 'Ficha Médica',
      value: 'ficha-medica',
      selected: true,
    },
    {
      icon: '',
      label: 'Remédios',
      value: 'remedios',
      selected: false,
    },
  ];

  formMedicacao = new FormGroup({
    nome: new FormControl('', Validators.required),
    medicacao_horarios: new FormControl('', Validators.required),
    ativo: new FormControl(true),
    observacao: new FormControl('', Validators.required),
    aluno: new FormControl(),
  });

  formMedicacaoHorario = new FormGroup({
    horario: new FormControl('', Validators.required),
    quantidade: new FormControl('', Validators.required),
  });

  medicacao_unidade: medicacao_unidade = {
    nome: '',
    ativo: true,
    sigla: '',
  };

  medicacao_horario: medicacao_horario = {
    dosagem: 0,
    horario: '',
    medicacao_unidade: 0,
  };

  medicacao: medicacao = {
    aluno: 0,
    ativo: true,
    medicacao_horarios: 0,
    nome: '',
    observacao: '',
  };

  tabsSelecionada: string = '';
  nomeAluno: any = '';
  editar: boolean = false;
  editarRemedio: boolean = false;
  camposObrigatoriosFormFichaMedica: boolean = false;
  fichaMedica: any;
  role: RoleEnum;
  aluno!: alunoResponse;
  documentIdAluno: any;
  idAluno!: any;

  optionsRemedios: OptionSelect[] = [
    {
      label: 'Comprimido',
      value: 'CP',
    },
    {
      label: 'Gotas',
      value: 'GT',
    },
    {
      label: 'ML',
      value: 'ML',
    },
  ];

  mostrarRemedios: any[] = [];

  idMedicacaoUnidade!: number;
  idMedicacaoHorario!: number;
  medicamentos: any;

  constructor(
    private readonly modalService: ModalService,
    private readonly navbarService: NavbarService,
    private readonly menuService: MenuService,
    private readonly alunoService: AlunosService,
    private readonly usuarioService: UserService,
    private readonly loaderService: LoaderService,
    private readonly toast: ToastService,
    private readonly storageService: StorageServiceService,
  ) {
    navbarService.setTitle('Ficha Médica');
    menuService.setSelected({
      icon: '',
      label: 'Ficha Médica',
      route: '/admin/ficha-medica',
      checked: true,
    });

    this.role = this.usuarioService.role as RoleEnum;

    this.alunoService.alunoSelecionado.subscribe((value) => {
      if (value === null) {
        this.documentIdAluno = this.storageService.obterAluno()?.documentId;
        this.idAluno = this.storageService.obterAluno()?.id;
        this.nomeAluno = this.storageService.obterAluno()?.nomeAluno;
        this.formMedicacao.controls.aluno.setValue(this.idAluno);
      } else {
        this.documentIdAluno = value?.documentId;
        this.idAluno = value?.id;
        this.nomeAluno = value?.nomeAluno;
        this.formMedicacao.controls.aluno.setValue(this.idAluno);
      }
      this.buscarAlunoPorId();
    });
  }

  formFichaMedica = new FormGroup({
    altura: new FormControl(''),
    peso: new FormControl(''),
    tipoSanguineo: new FormControl(''),
    carteiraSus: new FormControl(''),
    fatorrh: new FormControl(''),
    planoSaude: new FormControl(false),
    carteirinhaVacinacao: new FormControl(null),
    alergicoMedicamento: new FormControl(false),
    alergicoAlimento: new FormControl(false),
    doencaCongenita: new FormControl(false),
    fumante: new FormControl(false),
    caxumba: new FormControl(false),
    sarampo: new FormControl(false),
    rubeola: new FormControl(false),
    catapora: new FormControl(false),
    escarlatina: new FormControl(false),
    diabetico: new FormControl(false),
    insulina: new FormControl(false),
    medicaoEspecifica: new FormControl(false),
    acompanhamentoMedico: new FormControl(false),
    restricaoAtividadeFisica: new FormControl(false),
    traumaFratura: new FormControl(false),
    resposavelLevarParaHospital: new FormControl(''),
    emergenciaNomeResponsavel: new FormControl(''),
    emergenciaParentesco: new FormControl(''),
    emergenciaTelefone: new FormControl(''),
    emergenciaCelular: new FormControl(''),
    espectroAustista: new FormControl(false),
    tratamentoMedico: new FormControl(false),
    espectroAustistaTexto: new FormControl(''),
    nomesPlanosSaude: new FormControl(''),
    coqueluche: new FormControl(false),
    epiletico: new FormControl(false),
    hemofilico: new FormControl(false),
    hipertensao: new FormControl(false),
    asmatico: new FormControl(false),
    textoTratamentoMedico: new FormControl(''),
    textoMedicacaoEspecifica: new FormControl(''),
    textoAcompanhamentoMedico: new FormControl(''),
    textoRestricaoAtividadeFisica: new FormControl(''),
    textoTraumaFratura: new FormControl(''),
    textoAlergicoAlimento: new FormControl(''),
    textoAlergicoMedicamento: new FormControl(''),
    textoDoencaCongenita: new FormControl(''),
    aluno_id: new FormControl(),
    aluno: new FormControl<number>(0),
  });

  changeTabs($event: any) {
    this.tabsSelecionada = $event;
    if ($event === 'remedios') {
      this.buscarRemedios();
    }
  }

  buscarRemedios() {
    this.loaderService
      .executeWithLoader(this.alunoService.buscarMedicacoes(this.idAluno))
      .subscribe({
        next: (medicacoes) => {
          this.medicamentos = medicacoes.data;
        },
        error: () => {
          this.toast.notify({
            message: 'Erro ao buscar medicamentos do aluno !',
            type: 'ERROR',
          });
        },
      });
  }

  changeMedicacaoUnidade(event: OptionSelect) {
    this.medicacao_unidade.nome = event.label;
    this.medicacao_unidade.sigla = event.value;
  }

  buscarAlunoPorId() {
    this.loaderService
      .executeWithLoader(
        this.alunoService.buscarAlunoPorId(this.documentIdAluno),
      )
      .subscribe({
        next: (value) => {
          this.aluno = value.data;
        },
        error: (error) => {
          this.toast.notify({
            message: 'Tente novamente !',
            type: 'INFO',
          });
          this.editarForm();
        },
      });
  }

  salvarRemedio() {
    this.loaderService
      .executeWithLoader(
        this.alunoService.salvarMedicacaoUnidade(
          toPost(this.medicacao_unidade),
        ),
      )
      .pipe(
        switchMap((unidade) => {
          this.medicacao_horario = {
            dosagem: this.formMedicacaoHorario.controls.quantidade.value,
            horario: this.converterHorarioParaDate(
              this.formMedicacaoHorario.controls.horario.value,
            ),
            medicacao_unidade: unidade.data.id,
          };
          return this.loaderService
            .executeWithLoader(
              this.alunoService.salvarMedicacaoHorario(
                toPost(this.medicacao_horario),
              ),
            )
            .pipe(
              switchMap((horario) => {
                this.medicacao = {
                  aluno: this.aluno.id,
                  ativo: true,
                  medicacao_horarios: horario.data.id,
                  nome: this.formMedicacao.controls.nome.value as string,
                  observacao: this.formMedicacao.controls.observacao
                    .value as string,
                };
                return this.loaderService.executeWithLoader(
                  this.alunoService.salvarMedicacao(toPost(this.medicacao)),
                );
              }),
            );
        }),
      )
      .subscribe({
        next: (value) => {
          this.toast.notify({
            message: 'Lembrete cadastrado com Sucesso !',
            type: 'SUCCESS',
          });
          this.formMedicacao.reset();
          this.formMedicacaoHorario.reset();
          this.editarRemedio = !this.editarRemedio;
          this.buscarRemedios();
        },
        error: () => {
          this.toast.notify({ message: 'Erro Interno !', type: 'ERROR' });
        },
      });
  }

  converterHorarioParaDate(horarioStr: any): Date {
    const [horas, minutos] = horarioStr.split(':').map(Number);

    const agora = new Date();
    agora.setHours(horas, minutos, 0, 0);

    // Ajusta o fuso horário manualmente (ex.: GMT-3)
    const timezoneOffset = agora.getTimezoneOffset(); // em minutos
    agora.setMinutes(agora.getMinutes() - timezoneOffset);

    return agora;
  }

  salvarFichaMedica() {
    this.formFichaMedica.controls.aluno_id.setValue(this.documentIdAluno);
    this.formFichaMedica.controls.aluno.setValue(this.idAluno);

    if (this.editar) {
      if (this.aluno.ficha_medica === null) {
        this.loaderService
          .executeWithLoader(
            this.alunoService.cadastrarFichaMedica(
              toPost(this.formFichaMedica.value as any),
            ),
          )
          .subscribe({
            next: () => {
              this.toast.notify({
                message: 'Ficha Médica salva com Sucesso !',
                type: 'SUCCESS',
              });
              this.buscarAlunoPorId();
              this.editarForm();
            },
            error: () => {
              this.toast.notify({
                message: 'Tente novamente !',
                type: 'INFO',
              });
              this.editarForm();
            },
          });
      } else {
        this.loaderService
          .executeWithLoader(
            this.alunoService.editarFichaMedica(
              toPost(this.formFichaMedica.value as any),
              this.aluno.ficha_medica.documentId,
            ),
          )
          .subscribe({
            next: () => {
              this.toast.notify({
                message: 'Ficha Médica salva com Sucesso !',
                type: 'SUCCESS',
              });
              this.buscarAlunoPorId();
              this.editarForm();
            },
            error: () => {
              this.toast.notify({
                message: 'Tente novamente !',
                type: 'INFO',
              });
              this.editarForm();
            },
          });
      }
    }
  }

  deletarRemedio(idMedicamento: number) {
    this.loaderService
      .executeWithLoader(this.alunoService.deletarMedicamento(idMedicamento))
      .subscribe({
        next: () => {
          this.toast.notify({
            message: 'Medicamento deletado!',
            type: 'SUCCESS',
          });
          this.buscarRemedios();
        },
        error: (err) => {
          this.toast.notify({
            message: 'Erro interno!',
            type: 'ERROR',
          });
        },
      });
  }

  editarRemedios() {
    this.editarRemedio = !this.editarRemedio;
    this.formFichaMedica.reset();
    this.formMedicacao.reset();
    this.formMedicacaoHorario.reset();
  }

  editarForm() {
    this.editar = !this.editar;
    if (this.editar) {
      if (!(this.aluno.ficha_medica === null)) {
        this.loaderService
          .executeWithLoader(
            this.alunoService.buscarFichaMedicaPorId(
              this.aluno.ficha_medica.documentId,
            ),
          )
          .subscribe({
            next: (ficha) => {
              this.formFichaMedica.patchValue({
                altura: ficha.data.altura,
                peso: ficha.data.peso,
                tipoSanguineo: ficha.data.tipoSanguineo,
                carteiraSus: ficha.data.carteiraSus,
                fatorrh: ficha.data.fatorrh,
                planoSaude: ficha.data.planoSaude,
                alergicoMedicamento: ficha.data.alergicoMedicamento,
                alergicoAlimento: ficha.data.alergicoAlimento,
                doencaCongenita: ficha.data.doencaCongenita,
                fumante: ficha.data.fumante,
                caxumba: ficha.data.caxumba,
                sarampo: ficha.data.sarampo,
                rubeola: ficha.data.rubeola,
                catapora: ficha.data.catapora,
                escarlatina: ficha.data.escarlatina,
                diabetico: ficha.data.diabetico,
                insulina: ficha.data.insulina,
                tratamentoMedico: ficha.data.tratamentoMedico,
                medicaoEspecifica: ficha.data.medicaoEspecifica,
                acompanhamentoMedico: ficha.data.acompanhamentoMedico,
                restricaoAtividadeFisica: ficha.data.restricaoAtividadeFisica,
                traumaFratura: ficha.data.traumaFratura,
                resposavelLevarParaHospital:
                  ficha.data.resposavelLevarParaHospital,
                emergenciaNomeResponsavel: ficha.data.emergenciaNomeResponsavel,
                emergenciaParentesco: ficha.data.emergenciaParentesco,
                emergenciaTelefone: ficha.data.emergenciaTelefone,
                emergenciaCelular: ficha.data.emergenciaCelular,
                espectroAustista: ficha.data.espectroAustista,
                espectroAustistaTexto: ficha.data.espectroAustistaTexto,
                nomesPlanosSaude: ficha.data.nomesPlanosSaude,
                coqueluche: ficha.data.coqueluche,
                epiletico: ficha.data.epiletico,
                hemofilico: ficha.data.hemofilico,
                hipertensao: ficha.data.hipertensao,
                asmatico: ficha.data.asmatico,
                textoTratamentoMedico: ficha.data.textoTratamentoMedico,
                textoMedicacaoEspecifica: ficha.data.textoMedicacaoEspecifica,
                textoAcompanhamentoMedico: ficha.data.textoAcompanhamentoMedico,
                textoRestricaoAtividadeFisica:
                  ficha.data.textoRestricaoAtividadeFisica,
                textoTraumaFratura: ficha.data.textoTraumaFratura,
                textoAlergicoAlimento: ficha.data.textoAlergicoAlimento,
                textoAlergicoMedicamento: ficha.data.textoAlergicoMedicamento,
                textoDoencaCongenita: ficha.data.textoDoencaCongenita,
                aluno_id: ficha.data.aluno_id,
              });

              ficha.data.espectroAustista
                ? this.formFichaMedica.controls.espectroAustistaTexto.enable()
                : this.formFichaMedica.controls.espectroAustistaTexto.disable();
              ficha.data.planoSaude
                ? this.formFichaMedica.controls.nomesPlanosSaude.enable()
                : this.formFichaMedica.controls.nomesPlanosSaude.disable();
              ficha.data.alergicoMedicamento
                ? this.formFichaMedica.controls.textoAlergicoMedicamento.enable()
                : this.formFichaMedica.controls.textoAlergicoMedicamento.disable();
              ficha.data.alergicoAlimento
                ? this.formFichaMedica.controls.textoAlergicoAlimento.enable()
                : this.formFichaMedica.controls.textoAlergicoAlimento.disable();
              ficha.data.doencaCongenita
                ? this.formFichaMedica.controls.textoDoencaCongenita.enable()
                : this.formFichaMedica.controls.textoDoencaCongenita.disable();
              ficha.data.tratamentoMedico
                ? this.formFichaMedica.controls.textoTratamentoMedico.enable()
                : this.formFichaMedica.controls.textoTratamentoMedico.disable();
              ficha.data.medicaoEspecifica
                ? this.formFichaMedica.controls.textoMedicacaoEspecifica.enable()
                : this.formFichaMedica.controls.textoMedicacaoEspecifica.disable();
              ficha.data.acompanhamentoMedico
                ? this.formFichaMedica.controls.textoAcompanhamentoMedico.enable()
                : this.formFichaMedica.controls.textoAcompanhamentoMedico.disable();
              ficha.data.restricaoAtividadeFisica
                ? this.formFichaMedica.controls.textoRestricaoAtividadeFisica.enable()
                : this.formFichaMedica.controls.textoRestricaoAtividadeFisica.disable();
              ficha.data.traumaFratura
                ? this.formFichaMedica.controls.textoTraumaFratura.enable()
                : this.formFichaMedica.controls.textoTratamentoMedico.disable();
            },
          });
      }
    }
  }

  getHoraMinuto(dataIso: string): string {
    const data = new Date(dataIso);
    const horas = String(data.getUTCHours()).padStart(2, '0');
    const minutos = String(data.getUTCMinutes()).padStart(2, '0');
    return `${horas}:${minutos}`;
  }

  editarFicha() {
    this.editar = !this.editar;
  }

  removerRemedio(arg0: any) {
    this.mostrarRemedios.splice(arg0, 1);
  }

  adicionarRemedio() {
    this.mostrarRemedios.push(1);
  }

  espectroAutista(event: boolean) {
    this.formFichaMedica.controls.espectroAustista.setValue(event);
    event
      ? this.formFichaMedica.controls.espectroAustistaTexto.enable()
      : this.formFichaMedica.controls.espectroAustistaTexto.disable();
  }
  planoSaude(event: boolean) {
    this.formFichaMedica.controls.planoSaude.setValue(event);
    event
      ? this.formFichaMedica.controls.nomesPlanosSaude.enable()
      : this.formFichaMedica.controls.nomesPlanosSaude.disable();
  }
  alergicoMedicamento(event: boolean) {
    this.formFichaMedica.controls.alergicoMedicamento.setValue(event);
    event
      ? this.formFichaMedica.controls.textoAlergicoMedicamento.enable()
      : this.formFichaMedica.controls.textoAlergicoMedicamento.disable();
  }
  alergicoAlimento(event: boolean) {
    this.formFichaMedica.controls.alergicoAlimento.setValue(event);
    event
      ? this.formFichaMedica.controls.textoAlergicoAlimento.enable()
      : this.formFichaMedica.controls.textoAlergicoAlimento.disable();
  }
  congenita(event: boolean) {
    this.formFichaMedica.controls.doencaCongenita.setValue(event);
    event
      ? this.formFichaMedica.controls.textoDoencaCongenita.enable()
      : this.formFichaMedica.controls.textoDoencaCongenita.disable();
  }
  fumante(event: boolean) {
    this.formFichaMedica.controls.fumante.setValue(event);
  }
  caxumba(event: boolean) {
    this.formFichaMedica.controls.caxumba.setValue(event);
  }
  sarampo(event: boolean) {
    this.formFichaMedica.controls.sarampo.setValue(event);
  }
  rubeola(event: boolean) {
    this.formFichaMedica.controls.rubeola.setValue(event);
  }
  catapora(event: boolean) {
    this.formFichaMedica.controls.catapora.setValue(event);
  }
  escarlatina(event: boolean) {
    this.formFichaMedica.controls.escarlatina.setValue(event);
  }
  coqueluche(event: boolean) {
    this.formFichaMedica.controls.coqueluche.setValue(event);
  }
  epiletico(event: boolean) {
    this.formFichaMedica.controls.epiletico.setValue(event);
  }
  hemofilico(event: boolean) {
    this.formFichaMedica.controls.hemofilico.setValue(event);
  }
  hipertensao(event: boolean) {
    this.formFichaMedica.controls.hipertensao.setValue(event);
  }
  asmatico(event: boolean) {
    this.formFichaMedica.controls.asmatico.setValue(event);
  }
  diabetico(event: boolean) {
    this.formFichaMedica.controls.diabetico.setValue(event);
  }
  insulina(event: boolean) {
    this.formFichaMedica.controls.insulina.setValue(event);
  }
  tratamentoMedico(event: boolean) {
    this.formFichaMedica.controls.tratamentoMedico.setValue(event);
    event
      ? this.formFichaMedica.controls.textoTratamentoMedico.enable()
      : this.formFichaMedica.controls.textoTratamentoMedico.disable();
  }
  medicaoEspecifica(event: boolean) {
    this.formFichaMedica.controls.medicaoEspecifica.setValue(event);
    event
      ? this.formFichaMedica.controls.textoMedicacaoEspecifica.enable()
      : this.formFichaMedica.controls.textoMedicacaoEspecifica.disable();
  }
  acompanhamentoMedico(event: boolean) {
    this.formFichaMedica.controls.acompanhamentoMedico.setValue(event);
    event
      ? this.formFichaMedica.controls.textoAcompanhamentoMedico.enable()
      : this.formFichaMedica.controls.textoAcompanhamentoMedico.disable();
  }
  restricaoAtividadeFisica(event: boolean) {
    this.formFichaMedica.controls.restricaoAtividadeFisica.setValue(event);
    event
      ? this.formFichaMedica.controls.textoRestricaoAtividadeFisica.enable()
      : this.formFichaMedica.controls.textoRestricaoAtividadeFisica.disable();
  }
  traumaFratura(event: boolean) {
    this.formFichaMedica.controls.traumaFratura.setValue(event);
    event
      ? this.formFichaMedica.controls.textoTraumaFratura.enable()
      : this.formFichaMedica.controls.textoTratamentoMedico.disable();
  }
}

export interface medicacao_unidade {
  nome: string;
  ativo: boolean;
  sigla: string;
}

export interface medicacao_horario {
  horario: any;
  dosagem: any;
  medicacao_unidade: number;
}

export interface medicacao {
  nome: string;
  medicacao_horarios: number;
  ativo: boolean;
  observacao: string;
  aluno: number;
}
